<template>
  <vx-card>
    <h3>Send SMS</h3>
    <div class="smsc-box__item company-item-list">
      <label class="vs-input--label">Ani</label>
      <v-select
        multiple
        class="filter-select"
        :options="didList"
        v-model="payload.ani"
        label="name"
      />
    </div>
    <div class="my-5">
      <vs-radio v-model="type" vs-value="bulk" class="mr-4">Bulk</vs-radio>
      <vs-radio v-model="type" vs-value="import" class="mr-4">Import</vs-radio>
      <vs-radio v-model="type" vs-value="single"  class="mr-4">Single</vs-radio>
    </div>
    <div class=" mb-6" v-if="type === 'single'">
      <div class="smsc-box__item company-item-list">
        <label class="vs-input--label">DNIS</label>

        <vs-input
          type="number"
          style="width: unset"
          placeholder="Enter Numbers"

          v-model="payload.dnis"
        />

        <!--        <vs-input-number
                  multiple
                  class="filter-select"
                  :options="DNISList"
                  v-model="payload.dnis"
                  label="0"
                />-->
      </div>
    </div>
    <div class=" mb-6" v-else-if="type === 'import'">
      <span class="">UPLOAD  NUMBER LIST</span>
      <div class="mt-2">
<!--        <input type="file"  accept=".csv" :key="inputKey"  @change="onFileChange">-->
        <input type="file"   accept=".xlsx" :key="inputKey"  @change="onFileChange">
      </div>
    </div>
    <div v-else>
      <span class="mr-6">NUMBERS</span>
      <vs-textarea
        placeholder="Enter Numbers"
        height="160px"
        v-model="number"
      />
    </div>
    <div >
      <span class="mr-6">Message</span>
      <vs-textarea
        placeholder="Enter Message Content"
        height="160px"
        v-model="message"
        name="message"
      />
      <!--      <span class="text-danger text-xs">{{ errors.first('message') }}</span>-->
    </div>
    <div v-if="type === 'bulk'" class="my-3">
      <vs-checkbox v-model="random" class="mt-6">Enable Random Text</vs-checkbox>
    </div>
    <div class=" mb-6" v-if="type === 'single'">
      <vs-button @click="submitSingle">Submit</vs-button>
    </div>
    <div  class=" mb-6" v-else>
      <vs-button @click="submit">Submit</vs-button>
    </div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import TableMixin from '@/mixins/table.js'
import XLSX from "xlsx";

export default {
  components: {
    vSelect,
  },
  mixins: [TableMixin],
  data() {
    return {
      inputKey: 1,
      inputNumber:0,
      type: 'single',
      didList: [],
      DNISList: [],
      random: false,
      message: '',
      number: '',
      files: null,
      CSVFile:'',
      excelData: {
        header: null,
        results: null,
        meta: null
      },

      // Request data
      payload: {
        ani: null,
        dnis: null
      },
      uploadedNumbers:[]
    }
  },
  methods: {
    generateData ({ header, results, meta }) {
      this.excelData.header = header
      this.excelData.results = results
      this.excelData.meta = meta
      console.log('this.excelData.',this.excelData)
     // if (this.onSuccess) this.onSuccess(this.excelData)
    },
    getHeaderRow (sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C = undefined
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = `UNKNOWN ${  C}` // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    onFileChange(event) {
      this.files = event.target.files;
      if (!this.files || !this.files.length) {
        return;
      }
      if(!!this.files && (!this.files[0].name || this.files[0].name.split('.').pop().toLowerCase()!=='xlsx')){
        this.ShowErrorMessage({title:"Incorrect File",text: "File should be in .xlsx format"})
        setTimeout(() =>{
          this.inputKey++
          this.files = null
        },100)
        return
      }
      else {
        let file = this.files ?  this.files[0] : null
        this.destinations =  file
        this.createInput(file);
      }
    },
    createInput(file) {

    /*  const reader = new FileReader();
      reader.onload = (event) => {
        this.CSVFile = event.target.result
        return console.log(this.CSVFile);
      }
      reader.readAsText(file);*/
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {type: 'binary'});
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, {header: 1});
          console.log('data', data)
          this.uploadedNumbers = []
          data.map(e => {
            e.map(i => {
              this.uploadedNumbers.push(i.toString())
              return i.toString()
            })
          })
         // this.uploadedNumbers = this.uploadedNumbers[0]
          console.log(this.uploadedNumbers)
        }
        reader.readAsBinaryString(file);
      })
    },

    /* handleClick () {
       this.file = this.$refs.inputNewFile.files[0]
       if (this.file.type === "text/'csv' "){
         console.log('hello');
       }else console.log("hajox");

     },*/
    async submitSingle() {
      if(!this.message){
        this.requiredFields('Message')
        return;
      }
      let data = {
        ani: this.payload.ani ? this.payload.ani[0].value : '',
        dnis: this.payload.dnis ? this.payload.dnis : '',
        text: this.message,

      }

      this.$vs.loading()
      this.$store.dispatch('bulk/AddSMS', data)
        .then(res => {
          this.ShowSuccessMessage({ title: 'Success', text: 'Ok' })
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => {
          this.$vs.loading.close();
          this.message = '';
          this.payload.ani = null;
          this.payload.dnis = ''
        })
    },

    async submit() {
      // console.log(this.type,'32131564564')
      if(!this.number && this.type === 'bulk'){
        this.requiredFields('Number')
        return;
      }
      // console.log(this.type,'32131564564')
      if((!this.files/* || this.files[0].name.split('.').pop().toLowerCase()!=='csv'*/) && this.type === 'import'){
        this.message = ''
        this.requiredFields('UPLOAD  NUMBER LIST')
        return;
      }
      console.log(this.type,'32131564564')
      if(!this.message){
        this.requiredFields('Message')
        return;
      }
      console.log(this.type,'32131564564')
      // const valid = await this.$validator.validate()
      //
      // if (!valid) {
      //   return
      // }
      let destination = ''
      if(this.type === 'bulk'){
        destination = this.number.split(new RegExp('[ ,;\n]', 'g'))
      }else if(this.type === 'import'){
       // destination = this.CSVFile.split(new RegExp("[\\s,;]+", 'g')).filter(e => { return e != '' })
        destination = this.uploadedNumbers.filter(e => { return e != '' })
      }
      let data = {
        destinations: destination,
        text: this.message,
        add_random_text: this.random,
        nameFail:this.file,
      }

      this.$vs.loading()
      this.$store.dispatch('bulk/Add', data)
        .then(res => {
          this.ShowSuccessMessage({ title: 'Success', text: 'Ok' })
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => {
          this.$vs.loading.close();
          this.random = false;
          this.message = '';
          this.number = '';
          this.payload.ani = null
          setTimeout(() =>{
            this.inputKey++
            this.files = null
          },100)
        })
    },

    requiredFields(text) {
      this.$vs.notify({
        title: 'Warning',
        text: `The ${text} field is required`,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    },
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
    GetList () {
      this.$vs.loading()
      this.$store.dispatch('didcompany/GetList', {
        ...this.filters,
        page:  0,
        per_page:  100,
      })
        .then(res => {
          this.didList = res.items.map(this.TransformOptions)
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => this.$vs.loading.close())
    },
    TransformOptions (item) {
      return {
        name: item.did,
        value: item.did
      }
    },
  },
  created(){
    this.GetList()
  },
}
</script>

<style scoped>

</style>
